import { render, staticRenderFns } from "./ReservationsBookSpace127.vue?vue&type=template&id=4b45ec32&scoped=true"
import script from "./ReservationsBookSpace127.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationsBookSpace127.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReservationsBookSpace127.vue?vue&type=style&index=0&id=4b45ec32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b45ec32",
  null
  
)

export default component.exports